<div *ngIf="isLoading">
  <div *appSpinner="isLoading; message: 'Please wait...'"></div>
</div>

<div class="starting" *ngIf="isStarting">
  <img src="../../../../assets/img/logo1.svg" alt="" class="img">
</div>

<div *ngIf="!isStarting" class="generate-token-page-custom">
  <div class="container-generate-token">
    <div>
      <img src="../../../../assets/img/logo2.svg" alt="" class="img">
    </div>
    <div class="pb-5">
      <form #generateTokenForm="ngForm" name="generateTokenForm">

        <div class="form-group pb-3">
          <input #userEmail="ngModel" ngModel name="userEmail" type="email" class="form-control input-underline"
            aria-describedby="emailHelp" [attr.placeholder]="'generateToken.email' | translate" required
            [class.is-invalid]="userEmail.invalid && userEmail.touched">
        </div>
        <!-- <div class="error">
          {{error?.message}}
        </div> -->
        <br>
      </form>
      <div class="row col-12">
        <div class="button">
          <button class="btn generateToken_button w-100" (click)="attemptToGenerateToken($event, generateTokenForm)" translate>generateToken.generateToken</button>
        </div>
      </div>
    </div>
  </div>
</div>